export enum CompanyMilestoneColumn {
  Date = 'date',
  Note = 'note',
}
